export default "__VITE_ASSET__7Q3CMnI3__"